<app-location-modal
  [location]="selectedLocation()"
  [(isOpen)]="isModalOpen"
  [isDelete]="isDeleteMode()"
  (success)="fetchLocations(0, true)"
/>

<app-card
  title="Histórico de Localizações"
  styleClass="mb-4 lg:mb-0 h-full"
  [isLoading]="isCardLoading()"
>
  <div class="h-full max-h-[650px] overflow-y-auto">
    <ul class="h-full">
      @for(loc of locations(); track loc.id; let idx = $index) {
      <li>
        <div
          (click)="onModalOpen(false, idx, $event)"
          class="flex w-full align-center cursor-pointer bg-blue-100 text-gray-600 text-lg md:text-xl rounded-lg p-2 mb-2"
        >
          <p
            class="max-w-[80%] overflow-hidden text-ellipsis whitespace-nowrap"
          >
            <span class="font-semibold mr-2">
              {{ loc.createdAt | date : "dd/MM/yyyy" }}
            </span>
            |
            <span class="ml-2">
              {{ loc.detail }}
            </span>
          </p>

          <p-button
            class="ml-auto"
            icon="pi pi-trash"
            styleClass="p-button-danger p-button-md"
            (click)="onModalOpen(true, idx, $event)"
          />
        </div>
      </li>
      } @empty {
      <li class="list-none h-full">
        <div
          class="h-full w-full bg-gray-100 p-4 rounded-lg font-semibold flex justify-center items-center text-gray-400"
        >
          Nenhum registro encontrado
        </div>
      </li>
      } @if (locations().length && locations().length < totalLocations()) {
      <li class="list-none">
        <div class="flex justify-center">
          <p-button
            card-button
            type="button"
            icon="pi pi-plus"
            styleClass="font-semibold"
            label="Carregar mais"
            (click)="fetchLocations(nextPage())"
            [disabled]="isCardLoading()"
          />
        </div>
      </li>
      }
    </ul>
  </div>
</app-card>
